import "./cases.css";

import c1 from "./img/boostpad-case.png";
import c2 from "./img/mini-case3.jpg";
import c3 from "./img/mini-case4.jpg";

function CasesPrototype() {
	return (
		<div className="cases__container">
			<h4 className="cases__title">Кейсы</h4>
			<div className="cases__grid">
				<a
					href="/boostpad-ux-ui-launchpad"
					target="_blank"
					className="cases__item"
				>
					<img src={c1} alt="BoostPad - UX/Ul for cryptocurrency launchpad" />
				</a>

				<a
					href="https://equilibrium.io/"
					target="_blank"
					className="cases__item"
				>
					<img
						src={c2}
						alt="All-in-one DeFi hub of Polkadot. High leverage. Yet resilient"
					/>
				</a>
				<a
					href="https://www.behance.net/gallery/214171801/GoChinChin-Meeting-Mobile-App"
					target="_blank"
					className="cases__item"
				>
					<img
						src={c3}
						alt="GoChinChin это приложение по поиску встреч и общения с единомышленниками в комфортной и непринужденной атмосфере."
					/>
				</a>
			</div>
		</div>
	);
}

export default CasesPrototype;
